<mat-select
    [required]="to.required"
    [placeholder]="to.placeholder"
    [multiple]="to.isMultiSelect"
    [disabled]="to.disabled || to.readonly"
    [(value)]="selectedValue"
    [formlyAttributes]="field"
    (openedChange)="checkIfDropdownWasToggled($event)"
    (selectionChange)="onSelectedChange($event)">
    <ng-container *ngIf="listItem?.length; else empty">
      <!----For hierarchical list ----------->
      <ng-container *ngIf="isHierarchicalList">
        <ng-container *ngFor="let currentItem of topHierarchicalListItem">
        <div class="hierarchical-list-items" [ngClass]="{'hierarchical-list-items-background-color': !to.isMultiSelect}">
          <mat-checkbox color="primary" (change)="getSelectedValueFromHierarchicalTopItems(currentItem, $event)" *ngIf="to.isMultiSelect" [checked]="currentItem?.checked"></mat-checkbox>
          <label>{{currentItem.label | i18n_label}}</label>
        </div>
        </ng-container>

        <hr *ngIf="topHierarchicalListItem?.length > 0">
      </ng-container>
      <!----------------END------------------>
      <ng-template #recursiveMultiList let-listItem>
          <ng-container *ngFor="let currentItem of listItem">
              <ng-container *ngIf="!currentItem.items || currentItem.items?.length == 0 || to.listAnyLevelSelection">
                  <mat-option [value]="currentItem.value" [ngStyle]="{ 'padding-left': (16+currentItem.level*16) + 'px' }">
                      {{currentItem.label | i18n_label}}
                  </mat-option>
              </ng-container>

            <ng-container *ngIf="currentItem.items?.length > 0">
              <mat-optgroup *ngIf="!to.listAnyLevelSelection">
                  <label [ngStyle]="{ 'padding-left': (currentItem.level*16) + 'px' }">{{currentItem.label | i18n_label}}</label>
              </mat-optgroup>
              <ng-container *ngTemplateOutlet="recursiveMultiList; context:{ $implicit: currentItem.items }">
              </ng-container>
            </ng-container>
          </ng-container>
      </ng-template>

      <ng-container *ngTemplateOutlet="recursiveMultiList; context:{ $implicit: listItem }"></ng-container>
    </ng-container>
    <ng-template #empty>
      <mat-option disabled>No options to select</mat-option>
    </ng-template>
</mat-select>

